import type { KeyboardEvent } from 'react';

/**
 * antd InputNumber `formatter`/`parser` pair that restricts input to digits only.
 *
 * Blocks non-numeric characters (e.g. typing "dd") at the source so they can never
 * reach the InputNumber value nor the shared work-journey form state.
 */
export const digitsOnlyFormatter = (value?: string | number): string =>
  value === undefined || value === null ? '' : `${value}`.replace(/\D/g, '');

export const digitsOnlyParser = (displayValue?: string): string =>
  displayValue ? displayValue.replace(/\D/g, '') : '';

/**
 * onKeyDown guard that blocks any printable non-digit character before it is typed,
 * while still allowing editing/navigation keys (Backspace, arrows, Tab…) and
 * keyboard shortcuts (Ctrl/Cmd + key). Complements the parser, which also covers paste.
 */
export const blockNonDigitKeyDown = (
  event: KeyboardEvent<HTMLInputElement>,
): void => {
  if (event.ctrlKey || event.metaKey || event.altKey) {
    return;
  }
  // Printable single-character keys ("a", ".", "-"…) have length 1; keep only digits.
  if (event.key.length === 1 && !/\d/.test(event.key)) {
    event.preventDefault();
  }
};
